import {
  ActivityType, FileData, PersonType,
} from 'API';
import { useContext } from 'react';
import ActivityService from 'services/activity';
import CaseContext from 'shared/contexts/CaseContext';
import ProcessContext from 'shared/contexts/ProcessContext';
import CompanyContext from 'shared/contexts/CompanyContext';
import ProfileContext from 'shared/contexts/ProfileContext';
import UserContext from 'shared/contexts/UserContext';

const { createActivity } = ActivityService;

const useCreateFileUploadActivity = () => {
  const [userState] = useContext(UserContext);
  const { person } = userState;
  const [profile] = useContext(ProfileContext);
  const [process] = useContext(ProcessContext);
  const [thisCase] = useContext(CaseContext);
  const [company] = useContext(CompanyContext);

  const determineRecipients = (): Array<string> => {
    const recipients: Array<string> = [];
    if (company) {
      if (
        person.type === PersonType.Employer
        && company.accountManagerID
      ) {
        // If EM uploads to Company Profile --> Account Manager (MH)
        recipients.push(company.accountManagerID);
      }
    }

    if (profile && profile.type === PersonType.ForeignNational) {
      // If FN uploads to FN Profile --> MH user that created profile
      if (person.type === PersonType.ForeignNational) {
        if (profile.createdBy) {
          recipients.push(profile.createdBy);
        }
      } else {
        // If MH uploading to FN Profile --> FN
        recipients.push(profile.id!);
      }
    }

    if (thisCase) {
      // If FN or MHploads to Case --> Case Manager (MH)
      if (
        (person.type === PersonType.Employer
          || person.type === PersonType.ForeignNational)
        && thisCase.caseManagerID
      ) {
        recipients.push(thisCase.caseManagerID);
      }
    }

    return recipients || [];
  };

  return async (file: FileData) => {
    const activityInput: ActivityInput = {
      activityType: ActivityType.DOCUMENT_UPLOADED,
      actorID: person.id,
      actorType: person.type,
      directTargetID: file.id!,
      ownerID: company?.id || process?.id || profile?.id || thisCase?.id || '',
    };

    const recipients = determineRecipients();

    await createActivity(activityInput, recipients);
  };
};

export default useCreateFileUploadActivity;
